import { render, staticRenderFns } from "./atcBankAccount.vue?vue&type=template&id=22677280&"
import script from "./atcBankAccount.vue?vue&type=script&lang=ts&"
export * from "./atcBankAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports